import { useTranslation } from "react-i18next";
import { Col, Form, Row, Spin} from "antd";
import { FormInstance } from "antd/lib";
import { FunctionComponent } from "react";
import FormInput from "../../../../../components/form-input/FormInput";
import FormItemDropdown from "../../../../../components/form-dropdown/FormItemDropdown";



type FormCreateOrganizationProps = {
	form: FormInstance,
	onFinish?: any,
	loadingForm: boolean,
}

const FormCreateOrganization: FunctionComponent<FormCreateOrganizationProps> = ({ form, onFinish, loadingForm }) => {
  const { t } = useTranslation();

  const validations = {
	name: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (value && value.length > 512) {
				return Promise.reject(new Error(t("Tên tổ chức không vượt quá 512 ký tự", "Tên tổ chức không vượt quá 512 ký tự")))
			}
			if (!value) {
				return Promise.reject(new Error(t("Vui lòng nhập tên tổ chức", "Vui lòng nhập tên tổ chức")))
			}
			return Promise.resolve()
		}
	},
	code: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (value && value.length > 512) {
				return Promise.reject(new Error(t("Mã tổ chức không vượt quá 512 ký tự", "Mã tổ chức không vượt quá 512 ký tự")))
			}
			if (!value) {
				return Promise.reject(new Error(t("Vui lòng nhập mã tổ chức", "Vui lòng nhập mã tổ chức")))
			}
			return Promise.resolve()
		}
	},
	typeOrganization: {
		required: true,
		validator: (_: unknown, value: string) => {
			if (!value) {
				return Promise.reject(new Error(t("Vui lòng chọn loại tổ chức", "Vui lòng chọn loại tổ chức")))
			}
			return Promise.resolve()
		}
	},
}

	const listOption = [
		{
			code: t("Cơ quan bộ", "Cơ quan bộ"),
			name: t("Cơ quan bộ", "Cơ quan bộ"),
		},
		{
			code: t("Đơn vị khác", "Đơn vị khác"),
			name: t("Đơn vị khác", "Đơn vị khác"),
		},
	]
    return (
        <>
            <Form layout={"vertical"} form={form} onFinish={onFinish} name="createOrganization" initialValues={{ status : true}}>
				{loadingForm ? 
					<div className="statistic-course-content statistic-course-loading">
						<Spin size="large" />
					</div> 
					: 
					<Row gutter={[16,16]}>
						<Col span={24}>
							<Form.Item name="code" rules={[validations.code]} label={t("Mã tổ chức", "Mã tổ chức")}>
								<FormInput placeholder={t("Nhập mã tổ chức", "Nhập mã tổ chức")} />
							</Form.Item>
						</Col>
						<Col span={24}>
							<Form.Item name="name" rules={[validations.name]} label={t("Tên tổ chức", "Tên tổ chức")}>
								<FormInput placeholder={t("Nhập tên tổ chức", "Nhập tên tổ chức")} />
							</Form.Item>
						</Col>
						<Col span={24}>
							<Form.Item name="typeOrganization" rules={[validations.typeOrganization]} label={t("Loại tổ chức", "Loại tổ chức")}>
								<FormItemDropdown options={listOption} placeholder={t("Chọn loại tổ chức", "Chọn loại tổ chức")} />
							</Form.Item>
						</Col>
					</Row>
				}
			</Form>
        </>
    )
}

export default FormCreateOrganization;